import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, CircularProgress, FormHelperText, DialogActions, makeStyles } from '@material-ui/core';
import { useAppContext } from 'hooks/useAppContext';

const useStyles = makeStyles((theme) => ({
    cardHeader: {
        "background": theme.palette.primary.main,
        "color": theme.palette.primary.contrastText
    },
    paper: { minWidth: "600px" },
}));

const ImportToolbar = ({ moduleName="Materials", importedDataStore, updateImportedDataStore, updateStatusFunction, uploadFileAjaxFunction, saveDataAjaxFunction, convertDataFunction, handleUploadError, successfulSaveCallback, selectedRecords = [] }) => {
    const [importDialog, setImportDialog] = useState(false);
    const [progress, setProgress] = useState(false);
    const [saveBtn, setSaveBtn] = useState(true);
    const [importBtn, setImportBtn] = useState(false);
    const [fileData, setFileData] = useState();

    const { selectedProject } = useAppContext();

    const classes = useStyles();

    const handleImportButtonClick = () => setImportDialog(true);

    const onChangeHandler = event => setFileData(event.target.files[0]);

    const handleClose = () => { setImportDialog(false) };

    const handleImport = async () => {
        setProgress(true);

        const formData = new FormData();
        formData.append('value', fileData);

        uploadFileAjaxFunction(formData, selectedProject).then(res => {
            if (res.success) {
                // convertDataFunction now handles marking duplicates internally
                const data = convertDataFunction(res);

                // Log duplicate information for debugging
                if (res.data && res.existing && res.existing.length > 0) {
                    console.log(`Found ${res.existing.length} duplicate records out of ${data.length} total`);
                }

                if(data.length > 0) {
                    updateImportedDataStore(data);
                    updateStatusFunction("");
                    setImportBtn(true); // Disable import button after successful import
                } else {
                    updateStatusFunction(`No rows within the spreadsheet were able to be converted to ${moduleName.toLowerCase()}.`)
                }
            } else {
                const errorMessage = res.details?.message || "File Upload Error";
                updateStatusFunction(errorMessage)
            }
            setImportDialog(false)
            setSaveBtn(false)
            setProgress(false)
        })
    };

    const saveWorkItems = () => {
        // Only save checked records, filter out any with errors
        const _importedData = selectedRecords.filter(record => !record.Error);

        if (_importedData.length === 0) {
            updateStatusFunction("No valid records to save. Please select records without errors.");
            return;
        }

        saveDataAjaxFunction(_importedData).then(function (res) {
            if (res.success) {
                updateStatusFunction("");
                setImportBtn(false); // Re-enable import button after successful save
                setSaveBtn(true); // Disable save button again
                successfulSaveCallback();
            } else {
                updateStatusFunction("Issues were found in your upload, please remove or correct the flagged rows and retry saving.");
                handleUploadError(res.details.message);
            };
        }
        )
    }

    return (
        <>
            <div style={{ textAlign: 'right', paddingRight: '20px', paddingBottom: '20px' }}>
                <Button variant="contained" color="primary" onClick={saveWorkItems} disabled={saveBtn || selectedRecords.length === 0}> Save {moduleName} </Button>
                <span style={{ paddingRight: '30px' }}></span>
                <Button variant="contained" color="primary" onClick={handleImportButtonClick} disabled={importBtn}> Import {moduleName} </Button>
            </div>
            <Dialog open={importDialog} onClose={handleClose} disableBackdropClick maxWidth={'lg'} >
                <DialogTitle id="form-dialog-title" className={classes.cardHeader} >Import {moduleName}</DialogTitle>
                <DialogContent>
                    {progress ? <div> <CircularProgress />Importing {moduleName.toLowerCase()}</div> :
                        <div>
                            <FormHelperText>Select file to import {moduleName.toLowerCase()}</FormHelperText>
                            <div>
                                <input type="file" name="file" onChange={onChangeHandler} />
                            </div>
                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary"> Cancel</Button>
                    <Button color="primary" onClick={handleImport}> Import </Button>
                </DialogActions>
            </Dialog>
        </>
    )
};

export default ImportToolbar;